(() => {
  const eventPrefix = 'fieldsignal:';

  function track(name, detail = {}) {
    const payload = { ...detail, path: window.location.pathname };
    document.dispatchEvent(new CustomEvent(`${eventPrefix}${name}`, { detail: payload }));

    if (window.Shopify?.analytics?.publish) {
      Promise.resolve(window.Shopify.analytics.publish(`field_signal:${name}`, payload)).catch(() => {});
    }
  }

  function normalize(value) {
    return String(value || '').trim().toLowerCase();
  }

  function optionControls(group, optionName) {
    const scope = group.closest('.product-details') || document;
    const radios = Array.from(scope.querySelectorAll('input[data-option-name]'));
    const selects = Array.from(scope.querySelectorAll('select[name^="options["]'));

    return {
      radios: optionName
        ? radios.filter((input) => normalize(input.dataset.optionName) === normalize(optionName))
        : radios,
      selects: optionName
        ? selects.filter((select) => normalize(select.name.replace(/^options\[|\]$/g, '')) === normalize(optionName))
        : selects,
    };
  }

  function setOffer(button) {
    const group = button.closest('[data-fs-offers]');
    if (!group) return;

    const optionName = group.dataset.fsOfferOption || '';
    const offerValue = button.dataset.fsOfferValue || '';
    const allCards = group.querySelectorAll('[data-fs-offer-value]');

    allCards.forEach((card) => {
      card.setAttribute('aria-pressed', String(card === button));
    });

    const controls = optionControls(group, optionName);
    const matchingInput = controls.radios.find((input) => normalize(input.value) === normalize(offerValue));

    if (matchingInput && !matchingInput.checked) {
      matchingInput.click();
    } else {
      const matchingSelect = controls.selects.find((select) =>
        Array.from(select.options).some((option) => normalize(option.value) === normalize(offerValue))
      );

      if (matchingSelect) {
        const option = Array.from(matchingSelect.options).find(
          (candidate) => normalize(candidate.value) === normalize(offerValue)
        );
        matchingSelect.value = option.value;
        matchingSelect.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    track('bundle_select', {
      label: button.dataset.fsOfferLabel || button.textContent.trim(),
      value: offerValue,
    });
  }

  function syncOfferCards() {
    document.querySelectorAll('[data-fs-offers]').forEach((group) => {
      const optionName = group.dataset.fsOfferOption || '';
      const controls = optionControls(group, optionName);
      const selectedValue =
        controls.radios.find((input) => input.checked)?.value ||
        controls.selects.find((select) => select.value)?.value;

      if (!selectedValue) return;

      group.querySelectorAll('[data-fs-offer-value]').forEach((card) => {
        card.setAttribute('aria-pressed', String(normalize(card.dataset.fsOfferValue) === normalize(selectedValue)));
      });
    });
  }

  function enableScrollToBuy(button) {
    const productForm = document.querySelector('form[action*="/cart/add"]');
    if (!productForm) return;

    productForm.scrollIntoView({ behavior: 'smooth', block: 'center' });
    const offerCard = document.querySelector('[data-fs-offers] [data-fs-offer-value][aria-pressed="true"]');
    const firstFocusable =
      offerCard ||
      Array.from(productForm.querySelectorAll('input, select, button')).find(
        (element) => element.type !== 'hidden' && !element.disabled && element.offsetParent !== null
      );
    if (firstFocusable) {
      window.setTimeout(() => firstFocusable.focus({ preventScroll: true }), 450);
    }
    track('offer_jump');
  }

  function protectionMap(scope) {
    const mappingNode = scope.querySelector('[data-fs-protection-variants]');
    if (!mappingNode) return {};

    try {
      return JSON.parse(mappingNode.textContent || '{}');
    } catch (_) {
      return {};
    }
  }

  function setProtectionPlanForVariant(scope, productVariantId) {
    const planChoice = scope.querySelector('[data-fs-protection-choice="plan"]');
    if (!planChoice) return;

    const protection = protectionMap(scope)[String(productVariantId || '')];
    const choiceCard = planChoice.closest('[data-fs-protection-card]');

    if (!protection?.id) {
      planChoice.disabled = true;
      if (planChoice.checked) {
        const noPlanChoice = scope.querySelector('[data-fs-protection-choice="none"]');
        if (noPlanChoice) noPlanChoice.checked = true;
      }
      choiceCard?.setAttribute('data-fs-protection-unavailable', 'true');
      return;
    }

    planChoice.disabled = false;
    planChoice.dataset.fsProtectionVariant = String(protection.id);
    planChoice.dataset.fsProtectionTitle = protection.title || 'Field Signal Extreme Protection Plan';
    choiceCard?.removeAttribute('data-fs-protection-unavailable');

    scope.querySelectorAll('[data-fs-protection-price]').forEach((price) => {
      price.textContent = protection.price || '';
    });
  }

  function syncProtectionPlan(scope, productVariantId) {
    const productForm = scope.querySelector('form[action*="/cart/add"]');
    const currentVariantId = productVariantId || productForm?.querySelector('input[name="id"]')?.value;
    if (currentVariantId) setProtectionPlanForVariant(scope, currentVariantId);
  }

  function syncProtectionPurchasePath(choice) {
    const protection = choice.closest('[data-fs-protection]');
    const scope = protection?.closest('.product-details');
    const planSelected = choice.matches('[data-fs-protection-choice="plan"]') && choice.checked && !choice.disabled;
    const status = scope?.querySelector('[data-fs-protection-status]');

    protection?.querySelectorAll('[data-fs-protection-card]').forEach((card) => {
      card.toggleAttribute('data-fs-protection-selected', Boolean(card.querySelector(':checked')));
    });

    if (scope) {
      scope.dataset.fsProtectionSelected = String(planSelected);
    }

    if (!status) return;

    if (planSelected) {
      status.hidden = false;
      status.dataset.fsProtectionStatusMode = 'express-checkout';
      status.textContent = document.documentElement.dataset.fsExperimentArm === 'free'
        ? 'Your free 2-year protection will be included when you add your kit.'
        : 'Add to cart to include the selected 2-year plan. Express checkout is unavailable while it is selected.';
    } else if (status.dataset.fsProtectionStatusMode === 'express-checkout') {
      status.hidden = true;
      status.textContent = '';
      delete status.dataset.fsProtectionStatusMode;
    }
  }

  async function addSelectedProtection(event, productForm) {
    const scope = productForm.closest('.product-details') || document;
    const planChoice = scope.querySelector('[data-fs-protection-choice="plan"]:checked');
    if (!planChoice || planChoice.disabled) return;

    const variantInput = productForm.querySelector('input[name="id"]');
    const protectionVariantId = planChoice.dataset.fsProtectionVariant;
    if (!variantInput?.value || !protectionVariantId) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    const quantityInput = productForm.querySelector('[name="quantity"]');
    const productQuantity = Math.max(1, Number.parseInt(quantityInput?.value || '1', 10) || 1);
    const status = scope.querySelector('[data-fs-protection-status]');
    const submitButton = productForm.querySelector('[type="submit"]');
    const productVariantId = Number(variantInput.value);

    if (status) {
      status.hidden = false;
      status.textContent = 'Adding your selected product and 2-year plan…';
    }
    if (submitButton) submitButton.disabled = true;

    track('protection_plan_select', {
      selected: true,
      title: planChoice.dataset.fsProtectionTitle || '',
      productVariantId: String(productVariantId),
      protectionVariantId,
    });
    track('add_to_cart_start');

    try {
      const themeRoutes = typeof Theme !== 'undefined' ? Theme.routes : {};
      const response = await fetch(themeRoutes.cart_add_url || '/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [
            { id: productVariantId, quantity: productQuantity, properties: window.FieldSignalProtectionExperiment?.properties || {} },
            { id: Number(protectionVariantId), quantity: productQuantity, parent_id: productVariantId, properties: { ...window.FieldSignalProtectionExperiment?.properties, _fs_parent: crypto.randomUUID() } },
          ],
        }),
      });

      if (!response.ok) {
        const error = await response.json().catch(() => ({}));
        throw new Error(error.description || 'The selected 2-year plan could not be added.');
      }

      window.location.assign(themeRoutes.cart_url || '/cart');
    } catch (error) {
      if (status) {
        status.hidden = false;
        status.textContent = error.message || 'The selected 2-year plan could not be added. Please try again.';
      }
      if (submitButton) submitButton.disabled = false;
    }
  }

  async function addCartProtection(button) {
    const protection = button.closest('[data-fs-cart-protection]');
    const protectionVariantId = protection?.dataset.fsCartPlanVariant;
    const parentLineKey = protection?.dataset.fsCartParentLineKey;
    const parentVariantId = protection?.dataset.fsCartParentVariant || '';
    const model = protection?.dataset.fsCartModel || '';
    const offerUnits = protection?.dataset.fsCartOfferUnits || '';
    const parentQuantity = Math.max(1, Number.parseInt(protection?.dataset.fsCartParentQuantity || '1', 10) || 1);
    const status = protection?.querySelector('[data-fs-cart-protection-status]');

    if (!protectionVariantId || !parentLineKey) return;

    button.disabled = true;
    if (status) {
      status.hidden = false;
      status.textContent = 'Adding the protection plan to this item...';
    }

    try {
      const themeRoutes = typeof Theme !== 'undefined' ? Theme.routes : {};
      const properties = {
        ...window.FieldSignalProtectionExperiment?.properties,
        _fs_parent: parentLineKey,
        _fs_line_role: 'protection',
      };
      if (parentVariantId) properties._fs_parent_variant = parentVariantId;
      if (model) properties._fs_model = model;
      if (offerUnits) {
        properties._fs_offer_units = offerUnits;
        properties._fs_covered_pairs = offerUnits;
      }
      const response = await fetch(themeRoutes.cart_add_url || '/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [
            {
              id: Number(protectionVariantId),
              quantity: parentQuantity,
              parent_line_key: parentLineKey,
              properties,
            },
          ],
        }),
      });

      if (!response.ok) {
        const error = await response.json().catch(() => ({}));
        throw new Error(error.description || 'The protection plan could not be added.');
      }

      track('protection_plan_cart_add', {
        protectionVariantId,
        parentLineKey,
        quantity: parentQuantity,
      });
      window.location.reload();
    } catch (error) {
      if (status) {
        status.hidden = false;
        status.textContent = error.message || 'The protection plan could not be added. Please try again.';
      }
      button.disabled = false;
    }
  }

  function lockProtectionChildQuantityControls(root = document) {
    root.querySelectorAll('tr[data-fs-protection-child] cart-quantity-selector-component').forEach((selector) => {
      selector.querySelectorAll('button').forEach((button) => {
        button.disabled = true;
      });
    });
  }

  function scheduleProtectionChildQuantityLock() {
    [0, 100, 500, 1200, 2500].forEach((delay) => {
      window.setTimeout(() => lockProtectionChildQuantityControls(), delay);
    });
  }

  async function syncCartProtectionQuantity(event) {
    const quantitySelector = event.target.closest('cart-quantity-selector-component');
    const cartItems = quantitySelector?.closest('cart-items-component');
    const parentRow = quantitySelector?.closest('tr[data-key]');

    if (!quantitySelector || !cartItems || !parentRow) return;

    // A child plan can be removed on its own, but its quantity always follows its
    // parent. Horizon's quantity component may restore a button after it hydrates,
    // so stop its independent update path here as a second line of defense.
    if (parentRow.hasAttribute('data-fs-protection-child')) {
      event.stopImmediatePropagation();
      event.stopPropagation();
      const input = quantitySelector.querySelector('input[data-cart-quantity]');
      if (input) input.value = input.defaultValue;
      lockProtectionChildQuantityControls(cartItems);
      return;
    }

    const parentLineKey = parentRow.dataset.key;
    const protectionRow = Array.from(cartItems.querySelectorAll('tr[data-parent-key]')).find(
      (row) => row.dataset.parentKey === parentLineKey && row.hasAttribute('data-fs-protection-child')
    );
    if (!parentLineKey || !protectionRow?.dataset.key) return;

    const quantity = Math.max(1, Number.parseInt(event.detail?.quantity || '1', 10) || 1);
    const status = parentRow.querySelector('[data-fs-cart-protection-status]');
    const input = quantitySelector.querySelector('input[data-cart-quantity]');

    // Horizon handles cart quantity changes from a document listener. Stop it before
    // it submits a parent-only update, then keep the native nested plan in lockstep.
    event.stopImmediatePropagation();
    event.stopPropagation();
    quantitySelector.setAttribute('aria-busy', 'true');
    if (status) {
      status.hidden = false;
      status.textContent = 'Updating this item and its protection plan...';
    }

    try {
      const themeRoutes = typeof Theme !== 'undefined' ? Theme.routes : {};
      // Older paid carts can have identical Ajax child keys under different
      // parents. Normalize by line number before updating either line by key.
      const cartResponse = await fetch(`${themeRoutes.cart_url || '/cart'}.js`, { headers: { Accept: 'application/json' }, cache: 'no-store' });
      if (!cartResponse.ok) throw new Error('The cart could not be loaded. Please try again.');
      let cart = await cartResponse.json();
      const parentKey = (item) => item.parent_relationship?.parent_key || item.parent_relationship?.parent?.key;
      const selectedChild = cart.items.find((item) => item.key === protectionRow.dataset.key && parentKey(item) === parentLineKey);
      if (!selectedChild) throw new Error('Your cart changed. Please refresh before updating the quantity.');
      const protectionId = Number(selectedChild.variant_id);
      for (let attempt = 0; attempt < cart.items.length; attempt++) {
        const index = cart.items.findIndex((item) => Number(item.variant_id) === protectionId && parentKey(item) && !item.properties?._fs_parent);
        if (index < 0) break;
        const child = cart.items[index];
        const response = await fetch(themeRoutes.cart_change_url || '/cart/change.js', {
          method: 'POST', headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
          body: JSON.stringify({ line: index + 1, quantity: child.quantity, properties: { ...child.properties, _fs_parent: `${parentKey(child)}:${crypto.randomUUID()}` } }),
        });
        if (!response.ok) throw new Error('The protection plan could not be updated. Please try again.');
        cart = await response.json();
      }
      const children = cart.items.filter((item) => Number(item.variant_id) === protectionId && parentKey(item) === parentLineKey);
      const updates = { [parentLineKey]: quantity };
      // Repeated adds can create several plan lines under one parent. Keep one
      // matching line at the new quantity and remove extra copies.
      children.forEach((child, index) => { updates[child.key] = index === 0 ? quantity : 0; });
      const response = await fetch(themeRoutes.cart_update_url || '/cart/update.js', {
        method: 'POST',
        headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
        body: JSON.stringify({
          updates,
        }),
      });

      if (!response.ok) {
        const error = await response.json().catch(() => ({}));
        throw new Error(error.description || 'The cart quantity could not be updated.');
      }

      track('protection_plan_quantity_sync', { parentLineKey, quantity });
      window.location.reload();
    } catch (error) {
      if (input) input.value = input.defaultValue;
      if (status) {
        status.hidden = false;
        status.textContent = error.message || 'The cart quantity could not be updated. Please try again.';
      }
      quantitySelector.removeAttribute('aria-busy');
    }
  }

  document.addEventListener('click', (event) => {
    const cartProtectionButton = event.target.closest('[data-fs-cart-add-protection]');
    if (cartProtectionButton) {
      event.preventDefault();
      addCartProtection(cartProtectionButton);
      return;
    }

    const offerCard = event.target.closest('[data-fs-offer-value]');
    if (offerCard) {
      event.preventDefault();
      setOffer(offerCard);
      return;
    }

    const jumpButton = event.target.closest('[data-fs-scroll-to-buy]');
    if (jumpButton) {
      event.preventDefault();
      enableScrollToBuy(jumpButton);
      return;
    }

    const productMedia = event.target.closest('.product-media, [data-media-id], [data-testid*="product-media"]');
    if (productMedia) {
      track('gallery_interaction');
    }

    const checkoutButton = event.target.closest('[name="checkout"], [data-testid="checkout-button"]');
    if (checkoutButton) {
      track('checkout_start');
    }
  });

  document.addEventListener(
    'toggle',
    (event) => {
      const details = event.target;
      if (details.matches('[data-fs-faq]')) {
        track('faq_toggle', { label: details.dataset.fsFaq || '', open: details.open });
      }
    },
    true
  );

  // Horizon delegates product-form submits from document in capture phase.
  // Window is earlier in the event path, so a selected plan can stop the
  // native single-item request before it begins and submit one nested cart request.
  window.addEventListener(
    'submit',
    (event) => {
      const productForm = event.target.closest('form[action*="/cart/add"]');
      if (productForm) {
        addSelectedProtection(event, productForm);
      }
    },
    true
  );

  window.addEventListener('quantity-selector:update', (event) => {
    syncCartProtectionQuantity(event);
  }, true);

  document.addEventListener('submit', (event) => {
    const productForm = event.target.closest('form[action*="/cart/add"]');
    if (productForm) {
      track('add_to_cart_start');
    }
  });

  document.addEventListener('change', (event) => {
    if (event.target.matches('[data-fs-protection-choice]')) {
      syncProtectionPurchasePath(event.target);
      track('protection_plan_select', {
        selected: event.target.checked,
        title: event.target.dataset.fsProtectionTitle || '',
      });
    }

    if (event.target.matches('input[data-option-name], select[name^="options["]')) {
      const optionName =
        event.target.dataset.optionName || event.target.name.replace(/^options\[|\]$/g, '');
      track('variant_select', { optionName, value: event.target.value });
      syncOfferCards();

      const scope = event.target.closest('.product-details');
      if (scope) {
        syncProtectionPlan(scope, event.target.dataset.variantId);
      }
    }
  });

  function initialize() {
    syncOfferCards();
    document.querySelectorAll('[data-fs-protection]').forEach((protection) => {
      const scope = protection.closest('.product-details');
      if (!scope) return;

      syncProtectionPlan(scope);
      const selectedChoice = protection.querySelector('[data-fs-protection-choice]:checked');
      if (selectedChoice) syncProtectionPurchasePath(selectedChoice);
    });
    lockProtectionChildQuantityControls();
    scheduleProtectionChildQuantityLock();
    const productForm = document.querySelector('product-form-component[data-product-id]');
    if (productForm) {
      track('product_view', { productId: productForm.dataset.productId || '' });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
